import styled from '@emotion/styled'
import { PropsWithChildren } from 'react'

export interface InformationProps {}

export const Information = ({
  children
}: PropsWithChildren<InformationProps>) => {
  return <Base>{children}</Base>
}

const Base = styled('div')`
  display: flex;
  flex-direction: column;

  // Hide last divider inside of Information component
  & > .ant-divider:last-child {
    display: none;
  }
`
